<h3 mat-dialog-title>{{ data.title }}</h3>
<div mat-dialog-content>
  <p>{{ data.content }}</p>
</div>
<div class="hrz-end">
  <button mat-button color="surface" (click)="closeDialog(false)">Cancel</button>
  <button mat-flat-button color="error" (click)="closeDialog(true)">Delete</button>
</div>